<template>
  <Modal name="REMOVE_SERVICE_PROVIDER_USER" :title="titleLabel" actions>
    <template #body>
        <p class="font-weight-bold mb-1">{{ warningMessage }}</p>
        <p>{{ deleteMessage }}</p>
    </template>
    <template #actions>
      <div class="d-flex gap-1">
        <v-btn
          @click="closeModal"
          :disabled="isServiceProviderLoading"
          elevation="0"
          text
        >
          {{ cancelLabel }}
        </v-btn>
        <v-btn
          @click="remove"
          :loading="isServiceProviderLoading"
          color="primary"
          elevation="0"
        >
          {{ removeLabel }}
        </v-btn>
      </div>
    </template>
  </Modal>
</template>

<script>
// vue core
import { mapGetters, mapActions } from 'vuex'

// components
import Modal from '@/components/app/Modal.vue'

export default {
  name: 'RemoveServiceProviderUser',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['isServiceProviderLoading', 'serviceProviderUser']),

    deleteMessage() {
      return this.$t('deleteModal.warningMessage', {
        entityName: this.serviceProviderUser.name,
      })
    },
  },

  methods: {
    ...mapActions(['closeModal', 'removeServiceProviderUser']),

    remove() {
      this.removeServiceProviderUser(this.serviceProviderUser.id)
    },
  },

  data() {
    return {
      titleLabel: this.$t('realEstateUsers.label.remove'),
      warningMessage: this.$t('deleteModal.warning'),
      cancelLabel: this.$t('deleteModal.buttons.cancel'),
      removeLabel: this.$t('realEstateUsers.label.remove'),
    }
  }
}
</script>
